import React from "react";
import "./TermsAndConditions.css";

const TermsAndConditions = () => {
    return (
        <div className="terms-container">
            <h1 className="main-heading">Terms and Conditions</h1>
            <p>Welcome to our bookstore. By accessing or using our website, you agree to our terms and conditions.</p>

            <h3>1. Introduction</h3>
            <p>These terms apply to all users of our bookstore. They outline the rules and regulations for using our website and services. Please read them carefully to ensure a smooth experience.</p>

            <h3>2. User Accounts</h3>
            <p>To make purchases or access certain features, you may need to create an account. You are responsible for keeping your account details secure and ensuring that no unauthorized person gains access to it.</p>

            <h3>3. Purchases and Payments</h3>
            <p>All transactions must be completed through our secure payment system. We accept multiple payment methods, including credit/debit cards and digital wallets. If any payment issue arises, we reserve the right to cancel the order.</p>

            <h3>4. Pricing and Availability</h3>
            <p>Prices of books and other products are subject to change without prior notice. While we make every effort to ensure accurate pricing, errors may occur. In such cases, we reserve the right to correct any mistakes and adjust the pricing accordingly.</p>

            <h3>5. Shipping and Delivery</h3>
            <p>We offer shipping to various locations. Estimated delivery times depend on the shipping method selected and external factors. We are not responsible for delays caused by third-party couriers or unforeseen circumstances.</p>

            <h3>6. Returns and Refunds</h3>
            <p>Return and Refunds are not applicable for our products.</p>

            <h3>7. Intellectual Property</h3>
            <p>All content on our website, including images, text, and logos, is the intellectual property of our bookstore. Unauthorized reproduction or distribution is strictly prohibited.</p>

            <h3>8. User Conduct</h3>
            <p>Users must interact respectfully on our platform. Fraudulent activities, abusive behavior, or violation of our policies may result in account suspension or legal action.</p>

            <h3>9. Limitation of Liability</h3>
            <p>We are not liable for any direct, indirect, incidental, or consequential damages resulting from the use of our website or services. Users agree to use our services at their own risk.</p>

            <h3>10. Changes to Terms</h3>
            <p>We may update these terms and conditions at any time. Users will be notified of significant changes, and continued use of our services implies acceptance of the revised terms.</p>

            <h3>11. Contact Information</h3>
            <p>If you have any questions, concerns, or require assistance, please reach out to us at hifi785@gmail.com. We are happy to help.</p>
        </div>
    );
};

export default TermsAndConditions;
